import React from 'react';

import {Text} from '#component/base';

import * as css from '../BenefitsList.css';

export const SubscriptionBenefitsList = () => {
  return (
    <div>
      <Text className={css.BenefitLabel} as="h4" variant="body" color="burgundy">
        Benefits
      </Text>
      <Text className={css.BenefitLabel} color="doveGray">
        Enjoy 15% off your customized supplement stack each month with your Supplement Subscription.
      </Text>
    </div>
  );
};
